import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=62e0d807&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=62e0d807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0d807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e0d807')) {
      api.createRecord('62e0d807', component.options)
    } else {
      api.reload('62e0d807', component.options)
    }
    module.hot.accept("./Products.vue?vue&type=template&id=62e0d807&scoped=true&", function () {
      api.rerender('62e0d807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/Products.vue"
export default component.exports